export const DATE_FORMAT = 'YYYY-MM-DD';
export const VALID_TILL_DATE_MESSAGE = 'Please select valid till date';

// Vehicle Number Validation
export const VEHICLE_NUMBER_PATTERN =
	/^(?:[0-9]{2}BH[0-9]{4}[A-Z]{1,2}|[A-Z]{2}[0-9]{1,2}[A-Z]{1,3}[0-9]{1,4}|[A-Z]{2}[0-9]{4,8})$/;
export const VEHICLE_NUMBER_MESSAGE =
	'Please enter a valid vehicle number (e.g., DL01AB1234, 22BH1234AB)';

// CSV Template for Bulk Upload
export const BULK_UPLOAD_CSV_HEADERS = [
	'vendor_id',
	'vehicle_number',
	'vehicle_type_id',
	'rc_number',
	'rc_expiry_date',
	'rc_document_key',
	'insurance_number',
	'insurance_expiry_date',
	'insurance_document_key',
	'fitness_certificate_number',
	'fitness_expiry_date',
	'fitness_document_key',
	'pollution_certificate_number',
	'pollution_expiry_date',
	'pollution_document_key',
	'ownership_type',
	'gps_device_id',
];

/**
 * Generate CSV template for vehicle bulk upload
 * @returns {string} Data URL for the CSV file
 */
export const generateBulkUploadTemplate = () => {
	// Only include headers, no sample data rows
	const csvContent = BULK_UPLOAD_CSV_HEADERS.join(',');

	const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
	return URL.createObjectURL(blob);
};
